import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getFilteredWashes } from "../../State/Wash/Action";
import UpdateWashDialog from "./UpdateWashDialog";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import AppPagination from "../Tools/AppPagination";
import SearchWashDialog from "../Search/SearchWashDialog";
import moment from "moment/moment";
import { Button } from "@mui/material";
import PendingIcon from "@mui/icons-material/Pending";
import { getWashTypeLabel } from "../../constants/washTypes";

export default function WashList() {
  const dispatch = useDispatch();
  const { wash } = useSelector((store) => store);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("?vehicleType=CAR");
  const [vehicle, setVehicle] = useState("CAR");

  const handleVehicleChange = (vehicle) => {
    setVehicle(vehicle);
    setFilter(`?vehicleType=${vehicle}`);
    setPage(0);
  };

  useEffect(() => {
    let filter1 = `${filter}&page=${page}`;
    dispatch(getFilteredWashes(filter1));
    console.log(filter1);
  }, [dispatch, filter, page]);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex flex-row items-center justify-center gap-2 mt-2 mb-2">
        <Button
          variant={vehicle === "CAR" ? "contained" : "outlined"}
          color="primary"
          onClick={() => handleVehicleChange("CAR")}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          Car Wash
        </Button>
        <Button
          variant={vehicle === "BIKE" ? "contained" : "outlined"}
          color="primary"
          onClick={() => handleVehicleChange("BIKE")}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          Bike Wash
        </Button>

        <SearchWashDialog setFilter={setFilter} />
      </div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="p-4 text-center font-extrabold text-2xl">
            All Washes
          </h1>
        </div>
      </div>
      <div className="mx-auto sm:-mx-0 overflow-x-auto w-full ">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Booking Id
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Customer Name
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Address
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Number
              </th>

              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Wash Type
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Booking Date
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Workers
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Status</span>
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Update</span>
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Total Bill</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {wash?.pagedWash?.washes?.map((wash) => (
              <tr
                key={wash.bookingId}
                class="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                <td className="px-3 py-4 text-sm text-gray-500">
                  {wash.bookingId}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {wash.customerName}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {wash.address}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {wash?.vehicleNumber}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {wash.seater} - {getWashTypeLabel(wash.washType)}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {moment(wash.scheduledAt).format("lll")}
                </td>
                <td className="px-3 py-4 trucate text-sm text-gray-500">
                  {wash.workers}
                </td>

                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 text-center">
                  {wash.status === "IN_PROGRESS" && (
                    <PendingIcon size={20} color="success" />
                  )}
                  {wash.status === "COMPLETED" && <DoneIcon color="success" />}
                  {wash.status === "CANCELLED" && <CancelIcon color="error" />}
                </td>
                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 text-center">
                  <UpdateWashDialog
                    bookingId={wash.bookingId}
                    vehicle={wash.vehicle}
                    bookedAt={wash.scheduledAt}
                    seater={wash.seater}
                    workerIdList={wash.workerIds}
                    washType={wash.washType}
                  />
                </td>
                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  ₹ {Math.round(wash.totalBill)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <AppPagination
          setPage={setPage}
          totalPages={wash.pagedWash?.totalPages}
        />
        <div className="flex justify-center mt-4 mb-4">
          <Button
            href="/admin/wash-report"
            variant="contained"
            color="primary"
            sx={{ textDecoration: "underline", fontWeight: 500 }}
          >
            View All Reports
          </Button>
        </div>
      </div>
    </div>
  );
}
